var utils = require('@axd/widgets-utils');


var BaseClass = {

    init: function () {

    },

    create: function (extention) {
        var self = this;
        if (typeof(self) === 'function') {
            self = self.prototype;
        }
        var data = utils.extend(utils.extend({}, self), extention);
        var construnctor = function () {
            this.init.apply(this, arguments);
        };
        construnctor.prototype = data;
        construnctor.create = data.create;
        return construnctor;
    }
};

module.exports = BaseClass;



/*****************
 ** WEBPACK FOOTER
 ** ./client/helpers/BaseClass.js
 ** module id = 8
 ** module chunks = 0
 **/